import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { fluxInputOutline, fluxInputSizes } from "../flux/variants.js";
export const Input = React.forwardRef(({ className = "", invalid = false, inputSize = "base", ...rest }, ref) => {
    return (_jsx("input", { ref: ref, "data-invalid": invalid ? "true" : undefined, className: [fluxInputOutline, fluxInputSizes[inputSize], className].join(" "), ...rest }));
});
Input.displayName = "Input";
export const Textarea = React.forwardRef(({ className = "", invalid = false, ...rest }, ref) => {
    return (_jsx("textarea", { ref: ref, "data-invalid": invalid ? "true" : undefined, className: [
            fluxInputOutline,
            "min-h-[5rem] resize-y rounded-lg px-3 py-2 text-base sm:text-sm leading-[1.375rem]",
            className,
        ].join(" "), ...rest }));
});
Textarea.displayName = "Textarea";
